export default class ModeloAtividade {

  constructor(
    IdModeloAtividade, Descricao = '', Atividade, Observacoes,
    IdTipoAtividade, TipoAtividade, IdResponsavel, Responsavel, IdPrioridade,
    Prioridade, IdSituacao, Situacao, Duracao, Status = 'A', IdWorkflow, Workflow
  ) {
    this.IdModeloAtividade = IdModeloAtividade;
    this.Descricao = Descricao;
    this.Atividade = Atividade;
    this.Observacoes = Observacoes;
    this.IdTipoAtividade = IdTipoAtividade;
    this.TipoAtividade = TipoAtividade;
    this.IdResponsavel = IdResponsavel;
    this.Responsavel = Responsavel;
    this.IdPrioridade = IdPrioridade;
    this.Prioridade = Prioridade;
    this.IdSituacao = IdSituacao;
    this.Situacao = Situacao;
    this.Duracao = Duracao;
    this.Status = Status;
    this.IdWorkflow = IdWorkflow;
    this.Workflow = Workflow;
  }
  
}